'use strict';

Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.default = Column;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Job = require('./Job');

var _Job2 = _interopRequireDefault(_Job);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Column(_ref) {
		var title = _ref.title,
		    image = _ref.image,
		    jobs = _ref.jobs,
		    hasMatched = _ref.hasMatched,
		    matchMe = _ref.matchMe;

		return _react2.default.createElement(
				'div',
				{
						className: 'column'
				},
				_react2.default.createElement(
						'div',
						{ className: 'inner-column' },
						_react2.default.createElement(
								'div',
								{ className: 'column-icon' },
								_react2.default.createElement(_Icon2.default, { iconName: image.url, color: '#222829', height: 42 })
						),
						_react2.default.createElement(
								'h3',
								null,
								title
						),
						_react2.default.createElement(
								'div',
								{ className: 'job-column' },
								_react2.default.createElement(
										'div',
										{ className: 'job-column-info' },
										jobs.map(function (_ref2, key) {
												var match = _ref2.match,
												    jobTitle = _ref2.title,
												    jobSlug = _ref2.slug,
												    salary = _ref2.salary;
												return _react2.default.createElement(_Job2.default, {
														key: key,
														match: match,
														title: jobTitle,
														slug: jobSlug,
														salary: salary,
														hasMatched: hasMatched,
														matchMe: matchMe
												});
										})
								)
						)
				)
		);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/RolesAndEducation/Column.jsx
// module id = 1259
// module chunks = 0